module.exports = __webpack_public_path__ + "img/ic_import_primary.ef9e21e4.svg";